import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import AccordionIcon from '../../../../../components/Accordion/AccordionIcon'
import AccordionLabel from '../../../../../components/Accordion/AccordionLabel'
import CompensationAccordion from '../../../../../components/Accordion'
import { usePayoutPopupContext } from '../context'
import { useCompensationPopupStyles } from '../styles'
import PayoutLabel from '../components/PayoutLabel'

const BonusRate = () => {
  const classes = useStyles()
  const commonClasses = useCompensationPopupStyles()
  const { t } = useTranslation()
  const { data, updatePopoverPosition, isTotalBonusBiggerThanGuaranteed } = usePayoutPopupContext()

  const renderNpsBonusRateLabel = useCallback(
    (isOpened: boolean) => {
      if (!data) {
        return null
      }

      const className = clsx(commonClasses.accordionLabel, commonClasses.smallSpacingLabel, {
        [commonClasses.activeAqua75Label]: isOpened && isTotalBonusBiggerThanGuaranteed,
        [commonClasses.activeGrey200Label]: isOpened && !isTotalBonusBiggerThanGuaranteed,
        [commonClasses.aqua100Label]: !isOpened && isTotalBonusBiggerThanGuaranteed,
        [commonClasses.grey300Label]: !isOpened && !isTotalBonusBiggerThanGuaranteed,
      })

      return (
        <AccordionLabel
          className={className}
          icon={<AccordionIcon className={commonClasses.smallAccordionIcon} isOpened={isOpened} />}
        >
          <PayoutLabel
            label={t('compensation_popup_nps_bonus_rate_label')}
            value={data.bonusRate.nps.npsBonusRate * 100}
            format="percentage"
          />
        </AccordionLabel>
      )
    },
    [data, t, commonClasses, isTotalBonusBiggerThanGuaranteed]
  )

  if (!data) {
    return null
  }

  const bonusRateLabelClassName = {
    label: clsx(commonClasses.labelAsAccordion, classes.bonusRateLabel),
    value: clsx(commonClasses.labelAsAccordion, classes.bonusRateLabel),
  }

  return (
    <>
      <PayoutLabel
        classes={{
          label: clsx(commonClasses.labelAsAccordion, classes.bonusRateLabelAligned),
          value: commonClasses.labelAsAccordion,
        }}
        label={t('compensation_popup_bonus_rate_label')}
        value={data.bonusRate.bonusRate * 100}
        format="percentage"
      />

      <CompensationAccordion
        classes={{ opened: commonClasses.activeWhiteContent }}
        onToggleHandler={updatePopoverPosition}
        renderLabel={renderNpsBonusRateLabel}
      >
        <ul className={classes.bonusRateList}>
          <li>
            <PayoutLabel
              classes={bonusRateLabelClassName}
              label={t('compensation_popup_nps_range_label')}
              value={`${data.bonusRate.nps.npsRangeStart} - ${data.bonusRate.nps.npsRangeEnd}`}
              format="text"
            />
          </li>
          <li>
            <PayoutLabel
              classes={bonusRateLabelClassName}
              label={t('compensation_popup_personal_nps_score_label')}
              value={data.bonusRate.nps.personalNpsBonusScore}
              format="text"
            />
          </li>
        </ul>
      </CompensationAccordion>
    </>
  )
}

export default BonusRate

const useStyles = makeStyles({
  bonusRateList: {
    margin: 0,
    marginTop: 4,
    paddingBottom: 12,
  },
  bonusRateLabel: {
    paddingLeft: 0,
    paddingBottom: 0,
    paddingTop: 4,
    fontSize: 13,
  },
  bonusRateLabelAligned: {
    paddingLeft: 30,
  },
})
